import React from 'react';
import { string as stringProp } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { params, string, shape, useDataModel } from '@thd-nucleus/data-sources';
import { CONFIGURABLE_BLINDS } from '../../constants';
import './product-custom-options.scss';

export const ProductCustomOptions = ({ itemId }) => {
  const { data } = useDataModel('product', {
    variables: {
      itemId,
    }
  });

  const product = data?.product || {};

  const {
    globalCustomConfigurator = {}
  } = product?.info || {};
  const {
    productType
  } = product?.identifiers || {};

  const customExperience = globalCustomConfigurator?.customExperience;
  const configureProduct = productType === CONFIGURABLE_BLINDS;

  if (!customExperience || !configureProduct) {
    return null;
  }

  return (
    <div className="product-custom-options">
      <Image
        className="product-custom-options__image"
        alt="more-options-icon"
        asset="more-options.svg"
        width={42}
        height={31}
      />
      <span> Custom Options Available </span>
    </div>
  );
};

ProductCustomOptions.propTypes = {
  itemId: stringProp.isRequired
};

ProductCustomOptions.dataModel = {
  product: params({
    itemId: string().isRequired(),
  }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      productType: string(),
    }),
    info: shape({
      globalCustomConfigurator: shape({
        customExperience: string(),
      }),
    }),
  }),
};

ProductCustomOptions.displayName = 'ProductCustomOptions';
